
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 11.374c3.532.695 6 2.28 6 4.126 0 2.485-4.477 4.5-10 4.5S1 17.985 1 15.5c0-1.845 2.468-3.431 6-4.126M11 15V1l5.318 3.272c.388.24.581.358.643.509a.5.5 0 01-.011.407c-.07.146-.271.254-.672.47L11 8.5","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    